import A2PTheme from "./A2PTheme";

import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const overrides = {
  typography: {
    h1: {
      fontSize: "2.0em",
      fontWeight: "700",
    },
    h2: {
      fontSize: "1.5em",
      fontWeight: "700",
    },
    h3: {
      fontSize: "1.25em",
      fontWeight: "700",
    },
    h4: {
      fontSize: "1.15rem",
      fontWeight: "700",
    },
    h5: {
      fontSize: "1.285rem",
      fontWeight: "700",
    },
    h6: {
      fontSize: "1.142rem",
      fontWeight: "700",
    },
  },
};

const theme = {
  default: responsiveFontSizes(
    createTheme({
      ...A2PTheme,
      ...overrides,
    }),
  ),
  // domestic: responsiveFontSizes(
  //   createTheme(
  //     {
  //       typography: {
  //         fontFamily: `"Rakuten Sans", "Rakuten", "RakutenSans","Noto Sans","NotoSans", "Noto Sans CJK JP"`,
  //       },
  //     },
  //     { ...domesticTheme, ...overrides }
  //   )
  // ),
};
export default theme;
